<template>
  <div :class="`${rowClass} h-100`">
    <div :class="`${colClass} h-100`">
      <div class="h-100">
        <div v-if="block.image_url" class="mb-2 text-center">
          <img :src="block.image_url" :alt="block.image_alt" class="img-fluid" />
        </div>
        <div v-html="block.text"></div>
        <div v-if="block.button_text && block.button_url" class="text-center my-4">
          <b-button
            variant="branded"
            :href="buttonUrl"
            :target="block.button_target || '_self'"
            :style="buttonStyle"
            @click="onClickButton"
          >
            {{ block.button_text }}
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      block: Object,
    },
    computed: {
      buttonStyle() {
        if (!this.block.button_color) return null
        return `background-color: ${this.block.button_color}; border-color: ${this.block.button_color}`
      },
      buttonUrl() {
        let type = _.linkType(this.block.button_url, null, this.block.organization_id)
        let protocol = null
        if (type == 'email') protocol = 'mailto'
        else if (type == 'tel') protocol = 'tel'
        return _.compact([protocol, this.block.button_url]).join(':')
      },
      rowClass() {
        return this.block.span_row ? _.getRowClass(this.block) : null
      },
      colClass() {
        return this.block.span_row ? _.getColClass(this.block) : null
      },
    },
    methods: {
      onClickButton(e) {
        if (this.block.button_target == 'popup') {
          e.preventDefault()
          window.formIframeModalUpid = _.extractUpidFromUrl(this.block.button_url)
          this.$bvModal.show('form-iframe-modal')
        }
      },
    },
  }
</script>